// This file contains the variant mapping data for the Film Development Wizard
// Default variant mapping
var variantMapping = {
  "35mm": {
    // 35mm variants with Hold Negs
    "Color_C-41_Scan_and_Email_Standard_Resolution_Hold_Negs": 45324861374629,
    "Color_C-41_Scan_and_Email_High_Resolution_JPG_Hold_Negs": 45324861407397,
    "Color_C-41_Scan_and_Email_High_Resolution_TIFF_Hold_Negs": 45324861440165,
    "Color_C-41_Scan_and_Email_High_Resolution_BMP_Hold_Negs": 45324861472933,

    
    // 35mm variants with Bin Negs
    "Color_C-41_Scan_and_Email_Standard_Resolution_Bin_Negs": 45325246890149,
    "Color_C-41_Scan_and_Email_High_Resolution_JPG_Bin_Negs": 45325246988453,
    "Color_C-41_Scan_and_Email_High_Resolution_TIFF_Bin_Negs": 45325247086757,
    "Color_C-41_Scan_and_Email_High_Resolution_BMP_Bin_Negs": 45325247185061,
    
    // 35mm variants with Send Negs back
    "Color_C-41_Scan_and_Email_Standard_Resolution_Send_Negs_back": 45325246922917,
    "Color_C-41_Scan_and_Email_High_Resolution_JPG_Send_Negs_back": 45325247021221,
    "Color_C-41_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back": 45325247119525,
    "Color_C-41_Scan_and_Email_High_Resolution_BMP_Send_Negs_back": 45325247217829,
    
    // 35mm variants with Send Negs back with other
    "Color_C-41_Scan_and_Email_Standard_Resolution_Send_Negs_back_with_other": 45325246955685,
    "Color_C-41_Scan_and_Email_High_Resolution_JPG_Send_Negs_back_with_other": 45325247053989,
    "Color_C-41_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back_with_other": 45325247152293,
    "Color_C-41_Scan_and_Email_High_Resolution_BMP_Send_Negs_back_with_other": 45325247250597,
    
    // Black and White with Hold Negs
    "Black-and-White_Scan_and_Email_Standard_Resolution_Hold_Negs": 45324861636773,
    "Black-and-White_Scan_and_Email_High_Resolution_JPG_Hold_Negs": 45324861669541,
    "Black-and-White_Scan_and_Email_High_Resolution_TIFF_Hold_Negs": 45324861702309,
    "Black-and-White_Scan_and_Email_High_Resolution_BMP_Hold_Negs": 45324861735077,

    
    // Black and White with Bin Negs
    "Black-and-White_Scan_and_Email_Standard_Resolution_Bin_Negs": 45325247283365,
    "Black-and-White_Scan_and_Email_High_Resolution_JPG_Bin_Negs": 45325247381669,
    "Black-and-White_Scan_and_Email_High_Resolution_TIFF_Bin_Negs": 45325247479973,
    "Black-and-White_Scan_and_Email_High_Resolution_BMP_Bin_Negs": 45325247578277,
    
    // Black and White with Send Negs back
    "Black-and-White_Scan_and_Email_Standard_Resolution_Send_Negs_back": 45325247316133,
    "Black-and-White_Scan_and_Email_High_Resolution_JPG_Send_Negs_back": 45325247414437,
    "Black-and-White_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back": 45325247512741,
    "Black-and-White_Scan_and_Email_High_Resolution_BMP_Send_Negs_back": 45325247611045,
    
    // Black and White with Send Negs back with other
    "Black-and-White_Scan_and_Email_Standard_Resolution_Send_Negs_back_with_other": 45325247348901,
    "Black-and-White_Scan_and_Email_High_Resolution_JPG_Send_Negs_back_with_other": 45325247447205,
    "Black-and-White_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back_with_other": 45325247545509,
    "Black-and-White_Scan_and_Email_High_Resolution_BMP_Send_Negs_back_with_other": 45325247643813,
    
    // E-6 with Hold Negs
    "E-6_Slide_Film_Scan_and_Email_Standard_Resolution_Hold_Negs": 45324861898917,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_JPG_Hold_Negs": 45324861931685,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_TIFF_Hold_Negs": 45324861964453,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_BMP_Hold_Negs": 45324861997221,

    
    // E-6 with Bin Negs
    "E-6_Slide_Film_Scan_and_Email_Standard_Resolution_Bin_Negs": 45325247676581,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_JPG_Bin_Negs": 45325247774885,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_TIFF_Bin_Negs": 45325247873189,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_BMP_Bin_Negs": 45325247971493,
    
    // E-6 with Send Negs back
    "E-6_Slide_Film_Scan_and_Email_Standard_Resolution_Send_Negs_back": 45325247709349,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_JPG_Send_Negs_back": 45325247807653,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back": 45325247905957,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_BMP_Send_Negs_back": 45325248004261,
    
    // E-6 with Send Negs back with other
    "E-6_Slide_Film_Scan_and_Email_Standard_Resolution_Send_Negs_back_with_other": 45325247742117,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_JPG_Send_Negs_back_with_other": 45325247840421,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back_with_other": 45325247938725,
    "E-6_Slide_Film_Scan_and_Email_High_Resolution_BMP_Send_Negs_back_with_other": 45325248037029,
    
    // Cross Processing with Hold Negs
    "Cross_Processing_Scan_and_Email_Standard_Resolution_Hold_Negs": 45324862161061,
    "Cross_Processing_Scan_and_Email_High_Resolution_JPG_Hold_Negs": 45324862193829,
    "Cross_Processing_Scan_and_Email_High_Resolution_TIFF_Hold_Negs": 45324862226597,
    "Cross_Processing_Scan_and_Email_High_Resolution_BMP_Hold_Negs": 45324862259365,

    
    // Cross Processing with Bin Negs
    "Cross_Processing_Scan_and_Email_Standard_Resolution_Bin_Negs": 45325248069797,
    "Cross_Processing_Scan_and_Email_High_Resolution_JPG_Bin_Negs": 45325248168101,
    "Cross_Processing_Scan_and_Email_High_Resolution_TIFF_Bin_Negs": 45325248266405,
    "Cross_Processing_Scan_and_Email_High_Resolution_BMP_Bin_Negs": 45325248364709,
    
    // Cross Processing with Send Negs back
    "Cross_Processing_Scan_and_Email_Standard_Resolution_Send_Negs_back": 45325248102565,
    "Cross_Processing_Scan_and_Email_High_Resolution_JPG_Send_Negs_back": 45325248200869,
    "Cross_Processing_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back": 45325248299173,
    "Cross_Processing_Scan_and_Email_High_Resolution_BMP_Send_Negs_back": 45325248397477,
    
    // Cross Processing with Send Negs back with other
    "Cross_Processing_Scan_and_Email_Standard_Resolution_Send_Negs_back_with_other": 45325248135333,
    "Cross_Processing_Scan_and_Email_High_Resolution_JPG_Send_Negs_back_with_other": 45325248233637,
    "Cross_Processing_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back_with_other": 45325248331941,
    "Cross_Processing_Scan_and_Email_High_Resolution_BMP_Send_Negs_back_with_other": 45325248430245,
    
    // ECN-2 with Hold Negs
    "ECN-2_Cinematic_Film_Scan_and_Email_Standard_Resolution_Hold_Negs": 45324862423205,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_JPG_Hold_Negs": 45324862455973,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_TIFF_Hold_Negs": 45324862488741,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_BMP_Hold_Negs": 45324862521509,

    
    // ECN-2 with Bin Negs
    "ECN-2_Cinematic_Film_Scan_and_Email_Standard_Resolution_Bin_Negs": 45325248463013,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_JPG_Bin_Negs": 45325248561317,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_TIFF_Bin_Negs": 45325248659621,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_BMP_Bin_Negs": 45325248757925,
    
    // ECN-2 with Send Negs back
    "ECN-2_Cinematic_Film_Scan_and_Email_Standard_Resolution_Send_Negs_back": 45325248495781,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_JPG_Send_Negs_back": 45325248594085,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back": 45325248692389,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_BMP_Send_Negs_back": 45325248790693,
    
    // ECN-2 with Send Negs back with other
    "ECN-2_Cinematic_Film_Scan_and_Email_Standard_Resolution_Send_Negs_back_with_other": 45325248528549,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_JPG_Send_Negs_back_with_other": 45325248626853,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back_with_other": 45325248725157,
    "ECN-2_Cinematic_Film_Scan_and_Email_High_Resolution_BMP_Send_Negs_back_with_other": 45325248823461,
  },
  "120": {
    "Color_C-41_Scan_and_Email_Standard_Resolution_Hold_Negs": 45037372539045,
    "Color_C-41_Scan_and_Email_High_Resolution_JPG_Hold_Negs": 45037372571813,
    "Color_C-41_Scan_and_Email_High_Resolution_TIFF_Hold_Negs": 45037372604581,
    "Color_C-41_Scan_and_Email_High_Resolution_BMP_Hold_Negs": 45037372637349,

    "Color_C-41_Scan_and_Email_Standard_Resolution_Bin_Negs": 45037372670117,
    "Color_C-41_Scan_and_Email_High_Resolution_JPG_Bin_Negs": 45037372702885,
    "Color_C-41_Scan_and_Email_High_Resolution_TIFF_Bin_Negs": 45037372735653,
    "Color_C-41_Scan_and_Email_High_Resolution_BMP_Bin_Negs": 45037372768421,
    "Color_C-41_Scan_and_Email_Standard_Resolution_Send_Negs_back": 45327839723685,
    "Color_C-41_Scan_and_Email_High_Resolution_JPG_Send_Negs_back": 45327839756453,
    "Color_C-41_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back": 45327839789221,
    "Color_C-41_Scan_and_Email_High_Resolution_BMP_Send_Negs_back": 45327839821989,
    "Color_C-41_Scan_and_Email_Standard_Resolution_Send_Negs_back_with_other": 45327839854757,
    "Color_C-41_Scan_and_Email_High_Resolution_JPG_Send_Negs_back_with_other": 45327839887525,
    "Color_C-41_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back_with_other": 45327839920293,
    "Color_C-41_Scan_and_Email_High_Resolution_BMP_Send_Negs_back_with_other": 45327839953061,
    "Black-and-White_Scan_and_Email_Standard_Resolution_Hold_Negs": 45037373063333,
    "Black-and-White_Scan_and_Email_High_Resolution_JPG_Hold_Negs": 45037373096101,
    "Black-and-White_Scan_and_Email_High_Resolution_TIFF_Hold_Negs": 45037373128869,
    "Black-and-White_Scan_and_Email_High_Resolution_BMP_Hold_Negs": 45037373161637,

    "Black-and-White_Scan_and_Email_Standard_Resolution_Bin_Negs": 45037373194405,
    "Black-and-White_Scan_and_Email_High_Resolution_JPG_Bin_Negs": 45037373227173,
    "Black-and-White_Scan_and_Email_High_Resolution_TIFF_Bin_Negs": 45037373259941,
    "Black-and-White_Scan_and_Email_High_Resolution_BMP_Bin_Negs": 45037373292709,
    "Black-and-White_Scan_and_Email_Standard_Resolution_Send_Negs_back": 45327839985829,
    "Black-and-White_Scan_and_Email_High_Resolution_JPG_Send_Negs_back": 45327840018597,
    "Black-and-White_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back": 45327840051365,
    "Black-and-White_Scan_and_Email_High_Resolution_BMP_Send_Negs_back": 45327840084133,
    "Black-and-White_Scan_and_Email_Standard_Resolution_Send_Negs_back_with_other": 45327840116901,
    "Black-and-White_Scan_and_Email_High_Resolution_JPG_Send_Negs_back_with_other": 45327840149669,
    "Black-and-White_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back_with_other": 45327840182437,
    "Black-and-White_Scan_and_Email_High_Resolution_BMP_Send_Negs_back_with_other": 45327840215205,
    "Cross_Processing_Scan_and_Email_Standard_Resolution_Hold_Negs": 45037374111909,
    "Cross_Processing_Scan_and_Email_High_Resolution_JPG_Hold_Negs": 45037374144677,
    "Cross_Processing_Scan_and_Email_High_Resolution_TIFF_Hold_Negs": 45037374177445,
    "Cross_Processing_Scan_and_Email_High_Resolution_BMP_Hold_Negs": 45037374210213,

    "Cross_Processing_Scan_and_Email_Standard_Resolution_Bin_Negs": 45037374242981,
    "Cross_Processing_Scan_and_Email_High_Resolution_JPG_Bin_Negs": 45037374275749,
    "Cross_Processing_Scan_and_Email_High_Resolution_TIFF_Bin_Negs": 45037374308517,
    "Cross_Processing_Scan_and_Email_High_Resolution_BMP_Bin_Negs": 45037374341285,
    "Cross_Processing_Scan_and_Email_Standard_Resolution_Send_Negs_back": 45327840247973,
    "Cross_Processing_Scan_and_Email_High_Resolution_JPG_Send_Negs_back": 45327840280741,
    "Cross_Processing_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back": 45327840313509,
    "Cross_Processing_Scan_and_Email_High_Resolution_BMP_Send_Negs_back": 45327840346277,
    "Cross_Processing_Scan_and_Email_Standard_Resolution_Send_Negs_back_with_other": 45327840379045,
    "Cross_Processing_Scan_and_Email_High_Resolution_JPG_Send_Negs_back_with_other": 45327840411813,
    "Cross_Processing_Scan_and_Email_High_Resolution_TIFF_Send_Negs_back_with_other": 45327840444581,
    "Cross_Processing_Scan_and_Email_High_Resolution_BMP_Send_Negs_back_with_other": 45327840477349,
  },
  "APS": {
    "Color_C-41_Hold_Negs": 45327911878821,
    "Color_C-41_Bin_Negs": 45327911911589,
    "Color_C-41_Send_Negs_back": 45327911944357,
    "Color_C-41_Send_Negs_back_with_other": 45327911977125,
    "Black-and-White_Hold_Negs": 45327912009893,
    "Black-and-White_Bin_Negs": 45327912042661,
    "Black-and-White_Send_Negs_back": 45327912075429,
    "Black-and-White_Send_Negs_back_with_other": 45327912108197,
  },
  "110": {
    "Color_C-41_Hold_Negs": 45037381484709,
    "Color_C-41_Bin_Negs": 45037381615781,
    "Color_C-41_Send_Negs_back": 45327880978597,
    "Color_C-41_Send_Negs_back_with_other": 45327881011365,
    "Black-and-White_Hold_Negs": 45037382008997,
    "Black-and-White_Bin_Negs": 45037382140069,
    "Black-and-White_Send_Negs_back": 45327881044133,
    "Black-and-White_Send_Negs_back_with_other": 45327881076901,
  },
  "Prints": {
    "Matte_1_Set": 45037909278885,
    "Matte_2_Sets": 45037909344421,
    "Gloss_1_Set": 45037909246117,
    "Gloss_2_Sets": 45037909311653,
  },
};

// If a custom mapping is provided from the theme (via window.wizardVariantMapping), use it instead
if (typeof window !== 'undefined' && window.wizardVariantMapping && typeof window.wizardVariantMapping === 'object') {
  console.log('[DevWiz] Using custom variant mapping from theme settings');
  variantMapping = window.wizardVariantMapping;
} 